export default {
  allowButton: false,
  allowHeading: false,
  allowSocial: false,
  allowSubheading: false,
  displaySocialBlocksAsButtons: true
};